import { Button } from "@mui/material";
import { useContext, useEffect, useRef } from "react";
import useAPI from "../../../../api/hooks/useAPI";
import useColors from "../../../../api/hooks/useColors";
import CustomTooltip from "../../../../components/CustomTooltip";
import SpinningIcon from "../../../../components/SpinningIcon";
import { Toast } from "../../../../components/Toast";
import { NotificationContext } from "../../../../contexts/NotificationContext";

const UploadAgentImageButton = ({
  loadingMessage,
  setLoading,
  children,
  ...props
}) => {
  const { isLoading, setIsLoading } = useContext(NotificationContext);
  const colors = useColors();
  const { uploadAgentConnectorImage } = useAPI();
  const fileInputRef = useRef(null);

  useEffect(() => {
    setLoading(isLoading);
  }, [isLoading, setLoading]);

  const handleClick = () => {
    if (!isLoading && fileInputRef.current) {
      fileInputRef.current.value = "";
      fileInputRef.current.click();
    }
  };

  const handleFileChange = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    const isValidFilename =
      typeof file.name === "string" &&
      /^connector-[^/\\]+\.[A-Za-z0-9]+$/.test(file.name);
    if (!isValidFilename) {
      Toast.error(
        "File name must be in the form connector-<version>.<file_type> where version is in SemVer format (e.g., 0.1.0 or v1.2.3)"
      );
      return;
    }
    setIsLoading(true);
    try {
      await uploadAgentConnectorImage(file);
      Toast.success("Agent image uploaded successfully");
    } catch (error) {
      Toast.error("Failed to upload agent image");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
      <CustomTooltip title={isLoading ? loadingMessage : ""}>
        <span>
          <Button
            sx={{
              background: colors.grey_50,
              color: colors.contrast_text_dark,
              height: "32px",
              marginLeft: "5px",
              border: "1px solid",
              borderRadius: "8px",
            }}
            startIcon={<SpinningIcon isLoading={isLoading} />}
            onClick={handleClick}
            disabled={isLoading}
            {...props}
            style={{ textTransform: "none" }}
          >
            {children}
          </Button>
        </span>
      </CustomTooltip>
    </>
  );
};

export default UploadAgentImageButton;
